import React, { createContext, useContext, useEffect, useState } from "react";
import { useRouting } from "../hooks/useRouting/useRouting";
import { useLenis } from "lenis/react";

const AppContext = createContext({});
  
export const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const lenis = useLenis();

  const loadingTime = 1_250;

  useEffect(()=>{
    if (menuOpen){
      lenis?.stop?.();
    }else{
      lenis?.start?.();
    }
    
  },[menuOpen])

  const onNavigation = (url)=>{
    setMenuOpen(false);

    if (url !== prevUrl){
      setPrevUrl(url);
      return;
    }
    
    setTimeout(()=> setLoading(false), loadingTime / 2);
  }

  const routing = useRouting({ loadingTime, setLoading, onNavigation });
  const { url } = routing;
  const [prevUrl, setPrevUrl] = useState(url);

  useEffect(()=>{
    onNavigation(url);
  },[]);

  const context = {
    loading: loading || pageLoading,
    loadingTime,
    setLoading,
    pageLoading, setPageLoading,
    menuOpen, setMenuOpen,
    routing,
  }
  
  return (
    <AppContext.Provider value={context}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);